<template>
    <div class="admin-template-list" v-if="value">
        <header class="atl-header">
            <h2 class="atl-title"><span class="el-icon-arrow-left" @click="onClose"></span><span>{{projectName}}</span></h2>
        </header>
        <section class="atl-body"  v-loading="pageLoading"
                 element-loading-text="正在生成预览图..." element-loading-spinner="el-icon-loading">
            <h4 class="c-center c-gray"
                v-if="!pageLoading && singleDataList.length === 0 && singleGroupDataList.length === 0 && multipleDataList.length === 0"><i>无模板数据</i></h4>
            <section class="admin-single" v-if="singleGroupDataList.length > 0 || singleDataList.length > 0">
                <div class="bg" v-for="(item, index) in singleDataList" :key="`single-${index}`">
                    <h3>单图 - 未分组</h3>
                    <div class="tools">
                        <el-button type="default" @click="onHideTemplate(item)">隐藏/显示选中项</el-button>
                        <el-button type="primary" @click="onCopySelections(type_single, item.list)">复制选中项</el-button>
                        <el-button type="primary" @click="handleDelete(type_single, item.list, false, item.groupName)">删除选中项</el-button>
                    </div>
                    <ul>
                        <li v-for="(sItem, sIdx) in item.list" :key="sIdx">
                            <p class="tpl-name c-ellipsis" :title="sItem.name">{{sItem.name}}</p>
                            <div class="as-content">
                                <div class="as-body">
                                    <el-checkbox v-model="sItem.checked" size="medium"></el-checkbox>
                                    <div class="hover-bg" @click.stop="onChecked(sItem)" ></div>
                                    <img :src="sItem.defaultUrl" :title="sItem.name"/>
                                    <a @click="openGroupModal(type_single, group_type_pt, sItem)"  class="view-group-link">查看方案组</a>
                                    <p v-if="sItem.hidden" class="tpl-hidden c-tip" title="普通用户无法看到当前模板">模板已隐藏</p>
                                </div>
                                <p class="as-footer">PV: {{sItem.editPv || 0}}  UV: {{sItem.uv || 0}} 下载: {{sItem.downloadCount || 0}} 保存: {{sItem.saveCount || 0}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div  class="bg" v-for="(item, index) in singleGroupDataList" :key="`group-${index}`">
                    <h3>单图 - {{item.groupName}}</h3>
                    <div class="tools">
                        <el-button type="default" @click="onHideTemplate(item)">隐藏/显示选中项</el-button>
                        <el-button type="default" @click="onCopyGroup(type_single, item.list, true, item.groupName)">画布组复制</el-button>
                        <el-button type="primary" @click="onCopySelections(type_single, item.list, false, item.groupName)">复制选中项</el-button>
                        <el-button type="primary" @click="handleDelete(type_single, item.list, false, item.groupName)">删除选中项</el-button>
                    </div>
                    <ul>
                        <li v-for="(sItem, sIdx) in item.list" :key="sIdx">
                            <p class="tpl-name c-ellipsis" :title="sItem.name">{{sItem.name}}</p>
                            <div class="as-content">
                                <div class="as-body">
                                    <el-checkbox v-model="sItem.checked" size="medium"></el-checkbox>
                                    <div class="hover-bg" @click.stop="onChecked(sItem)"></div>
                                    <img :src="sItem.defaultUrl" :title="sItem.name"/>
                                    <a @click="openGroupModal(type_single, group_type_pt, sItem)" class="view-group-link">查看方案组</a>
                                    <p v-if="sItem.hidden" class="tpl-hidden c-tip" title="普通用户无法看到当前模板">模板已隐藏</p>
                                </div>
                                <p class="as-footer">PV: {{sItem.editPv || 0}}  UV: {{sItem.uv || 0}} 下载: {{sItem.downloadCount || 0}} 保存: {{sItem.saveCount || 0}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
            <section class="admin-multiple" v-for="(item, index) in multipleDataList" :key="index">
                <div class="bg">
                    <h3>图文 - {{item.groupName}}</h3>
                    <div class="tools">
                        <el-button type="default" @click="onHideTemplate(item)">隐藏/显示选中项</el-button>
                        <el-button type="default" @click="onCopyGroup(type_multiple, item.list, true, item.groupName)">画布组复制</el-button>
                        <el-button type="primary" @click="onCopySelections(type_multiple, item.list, true, item.groupName)">复制选中项</el-button>
                        <el-button type="primary" @click="handleDelete(type_multiple, item.list, true, item.groupName)">删除选中项</el-button>
                    </div>
                    <ul>
                        <li v-for="(sItem, sIdx) in item.list" :key="sIdx">
                            <p class="tpl-name c-ellipsis" :title="sItem.name">{{sItem.name}}</p>
                            <div class="as-content">
                                <div class="as-body">
                                    <el-checkbox v-model="sItem.checked" size="medium"></el-checkbox>
                                    <div class="hover-bg" @click="onChecked(sItem)"></div>
                                    <img :src="sItem.defaultUrl" :title="sItem.name" />
                                    <a @click="openGroupModal(type_multiple, group_type_mk, sItem)" class="view-group-link">查看方案组</a>
                                    <p v-if="sItem.hidden" class="tpl-hidden c-tip" title="普通用户无法看到当前模板">模板已隐藏</p>
                                </div>
                                <p class="as-footer">PV: {{sItem.editPv || 0}}  UV: {{sItem.uv || 0}} 下载: {{sItem.downloadCount || 0}} 保存: {{sItem.saveCount || 0}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
        </section>
        <el-dialog key="101" :visible.sync="dialogValue" title="复制到"
                   custom-class="template-copy-dialog"
                   append-to-body
                   width="650px"
                   :close-on-click-modal="false"
                   class="global-dialog">
            <section class="atl-tools">
                <label>项目分组: </label>
                <div v-for="(item, index) in targetProjectGroups" :key="index">
                  <el-select v-model="item.targetProjectValue" placeholder="请选择项目" @change="onProjectChange">
                    <el-option
                            v-for="(item, index) in projectList"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                  </el-select>
                  <el-select v-model="item.targetGroupValue"  allow-create filterable placeholder="请选择分组">
                      <el-option :value="''" label="不分组">
                        不分组
                      </el-option>
                      <el-option
                              v-for="(item, index) in groupCache[item.targetProjectValue] || []"
                              :key="`${index}`"
                              :label="item.name"
                              :value="item.name">
                      </el-option>
                  </el-select>
                  <i v-if="targetProjectGroups.length > 1" @click="deleteTargetProject(index)" class="iconfont icon-close"></i>
                </div>
                <el-button @click="addTargetProject" type="primary">添加一条</el-button>
                <!--<el-input v-model="targetGroupValue"  style="width: 217px"></el-input>-->
            </section>
            <div slot="footer">
                <el-button @click="onCancel" type="default">取消</el-button>
                <el-button @click="onConfirmCopy" type="primary">确认</el-button>
            </div>
        </el-dialog>
        <group-dialog key="102" v-model="groupModalVisible" :data="groupModalData"></group-dialog>
    </div>
</template>
<script>
    import templateService from '../../../request/service/template-service';
    import projectService from '../../../request/service/project-service';
    import {template_type_single, template_type_multiple, group_type_pt, group_type_mk} from '@/const';
    import groupDialog from './group-dialog'
    export default {
        components: {groupDialog},
        props:{
            value: Boolean,
            projectName: String,
            projectId: String,
        },
        data(){
            return {
                group_type_pt, group_type_mk,
                type_single:template_type_single,
                type_multiple:template_type_multiple,
                targetProjectValue: null,
                targetGroupValue: null,
                targetGroupList:[],
                singleDataList: [],
                singleGroupDataList: [],
                multipleDataList: [],
                pageLoading: false,
                dialogValue: false,
                groupModalData:{tplType: '', type: '', projectId: '', templateIds: null},
                groupModalVisible: false,
                targetProjectGroups: [],
                groupCache: {},
                projectList: []
            }
        },
        computed:{
            // projectList(){
            //     return this.$store.state.app.loginUser.projectItems;
            // }
        },
        watch:{
            value: {
                handler(v){
                    if(v){
                        this.init();
                    }
                },
                immediate: true
            }
        },
        created(){
            this.getProjectList();
        },
        methods:{
            init(){
                this.getData();
            },
            getProjectList(){
                projectService.getSystemProjectList().then((data) => {
                    this.projectList = data;
                    this.targetProjectValue = this.projectList[0].id;
                });
            },
            getData(){
                this.pageLoading = true;
                templateService.getTemplateListByProjectId(this.projectId).then((data) => {
                    this.formatterData(data);
                }).finally(() => {
                    this.pageLoading = false;
                });
            },
            getGroupData(data) {
                let obj = {}, objItem;
                data.forEach((item) => {
                    objItem = obj[item.tplGroupId];
                    if(objItem){
                        objItem.list.push(item);
                    } else {
                        obj[item.tplGroupId] = {
                            groupName: item.tplGroupName,
                            list: [item]
                        }
                    }
                });
                let result = [];
                for(let key in obj){
                    result.push(obj[key]);
                }
                return result;
            },
            formatterData(dataList){
                let singleDataList = [], singleGroupDataList = [], multipleDataList = [];
                dataList.forEach((item) => {
                    if(item.type === template_type_single){
                        if(item.tplGroupId && !item.isDefaultTplGroup){
                            singleGroupDataList.push(item)
                        } else {
                            singleDataList.push(item);
                        }
                    } else if(item.type !== template_type_single){
                        multipleDataList.push(item);
                    }
                });
                this.singleDataList = singleDataList.length > 0 ? [{list: singleDataList}]: [];
                this.singleGroupDataList = this.getGroupData(singleGroupDataList);
                this.multipleDataList = this.getGroupData(multipleDataList);
            },
            getCheckedTemplateIds(dataList, isAll){
                let arr = [];
                dataList.forEach((item) => {
                    if(isAll){
                        arr.push(item.id);
                    } else if(item.checked){
                        arr.push(item.id);
                    }
                });
                return arr;
            },
            async onProjectChange(projectId){
                // this.groupCache = this.groupCache || {};
                if(!this.groupCache[projectId]){
                    let data = await templateService.getTemplateGroupByProjectId(projectId, this.type).catch();
                    if(data){
                        data = data.filter((item) => {
                            return !item.isDefault;
                        });
                    }
                    // this.groupCache[projectId] = data || [];
                    this.groupCache = Object.assign({}, this.groupCache, {[projectId]: data || []})
                }
                this.targetGroupValue = '';
                this.targetGroupList = this.groupCache[projectId] || [];
                if(this.targetGroupList.length > 0){
                    this.targetGroupValue = this.targetGroupList[0].name;
                }
            },
            openConfirm(msg){
              return this.$confirm(msg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              })
            },
            onCancel(){
                this.dialogValue = false;
            },
            onConfirmCopy(){
                let v = this.targetGroupValue;
                let isEmpty = v === null || v === undefined || v.trim() === '';
                // if(this.groupNameRequired && isEmpty){
                //     this.$message.error('分组不能为空');
                //     return;
                // }
                let idList = this.templateIdList;
                if(idList && idList.length > 0){
                    this.openConfirm(`确认复制"${idList.length}个"模板`).then(() => {
                        // this.saveData(this.targetProjectValue, v, idList);
                        this.saveData(idList);
                        this.dialogValue = false;
                    }).catch(() => {});
                }
            },
            addTargetProject () {
              this.targetProjectGroups.push({
                targetProjectValue: this.projectList[0].id,
                targetGroupValue:  this.targetProjectGroups[0].targetGroupValue
              });
            },
            deleteTargetProject (index) {
              this.targetProjectGroups.splice(index, 1);
            },
            saveData(idList){
              console.log(this.targetProjectGroups)
                let data =  {
                    'sourceIds': idList,
                    'targetProjectGroups': this.targetProjectGroups.map(e => ({
                      groupName: e.targetGroupValue,
                      projectId: e.targetProjectValue
                    }))
                    // 'targetProjectGroups': [
                    //     {
                    //         'groupName': targetGroupValue,
                    //         'projectId': targetProjectValue
                    //     }
                    // ]
                }
                templateService.copyTemplates(data).then(() => {
                    this.$message.success('复制成功');
                }).catch(() => {
                  this.$message.success('复制失败');
                });
            },
            onClose(){
                this.$emit('input', false);
            },
            onChecked(item){
                if(item.hasOwnProperty('checked')){
                    item.checked = !item.checked;
                } else {
                    this.$set(item, 'checked', true);
                }
            },
            onCopyGroup(type, dataList, groupNameRequired, groupName){
                this.targetProjectGroups = [
                  {
                    targetProjectValue: this.projectList[0].id,
                    targetGroupValue: groupName
                  }
                ]
                this.type = type;
                this.groupNameRequired = groupNameRequired;
                this.targetGroupValue = groupName;
                this.templateIdList = this.getCheckedTemplateIds(dataList, true);
                this.onProjectChange(this.targetProjectValue);
                this.dialogValue = true;
            },

            onCopySelections(type, dataList, groupNameRequired, groupName){
                this.targetProjectGroups = [
                  {
                    targetProjectValue: this.projectList[0].id,
                    targetGroupValue: groupName
                  }
                ]
                this.type = type;
                this.groupNameRequired = groupNameRequired;
                this.targetGroupValue = groupName;
                this.templateIdList = this.getCheckedTemplateIds(dataList, false);
                if(this.templateIdList.length === 0){
                    this.$message.error('请勾选模板');
                    return;
                }
                this.onProjectChange(this.targetProjectValue);
                this.dialogValue = true;
            },
            handleDelete(type, dataList, groupNameRequired, groupName) {
                this.templateIdList = this.getCheckedTemplateIds(dataList, false);
                if(this.templateIdList.length === 0){
                    this.$message.error('请勾选模板');
                    return;
                }
                this.$confirm(`确定删除 ${this.templateIdList.length} 个模板？<br/> 删除后不可恢复`, '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    loading: true
                }).then(() => {
                    templateService.deleteTemplates(this.templateIdList).then(() => {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getData();
                    });
                }).catch(() => {
                });
            },
            openGroupModal(tplType, type, item){
                this.groupModalData = {
                    tplType,
                    type,
                    projectId: item.projectId,
                    templateIds: [item.id]
                }
                this.groupModalVisible = true;
            },
            onHideTemplate(item){
                let idArray = this.getCheckedTemplateIds(item.list, false);
                if(idArray && idArray.length > 0){
                    templateService.hideTemplate(item.projectId, idArray, true).then(() => {
                        this.$message.success({
                            message: '操作成功',
                            duration: 1000
                        });
                        item.list.forEach((obj) => {
                            if(idArray.indexOf(obj.id) > -1){
                                obj.hidden = !obj.hidden;
                            }
                        });
                    });
                }
            }
        }
    }
</script>
<style lang="scss">
    @import "./template-list";
</style>